export default "__VITE_ASSET__RX0I79e$__"